"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixSoon = fixSoon;
exports.fix = fix;
exports.setup = setup;
exports.default = void 0;

var _jquery = babelHelpers.interopRequireDefault(require("jquery"));

var _decorators = require("decorators");

var _class, _temp;

var TabbedContentHelper = (_class = (_temp =
/*#__PURE__*/
function () {
  function TabbedContentHelper() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    babelHelpers.classCallCheck(this, TabbedContentHelper);
    this.tabContentRoot = typeof document == 'undefined' ? null : document;
    this.tabRootElementSelector = '.objectBodyTabContent:not(.react)';
    this.tabContentElementSelector = '.tab-content';
    this.tabPaneElementSelector = '.tab-pane';
    this.activeSelector = '.active';
    this.tabPaneContentSelector = '.objectBodyTab';
    this.tabBarSelector = '.objectBodyTabs';
    this.t0 = null;
    this.tid = null;
    this.ignored = null;
    this.finished = null;
    this.wh = null;
    this.ww = null;
    this.d = null;
    this.paused = null;
    this.isPointer = false;
    Object.assign(this, options);
    this.fixSoonTimeout = null;
  }

  babelHelpers.createClass(TabbedContentHelper, [{
    key: "fix",
    value: function fix() {
      var E = (0, _jquery.default)(this.tabContentRoot).find("".concat(this.tabRootElementSelector, " ").concat(this.tabContentElementSelector));
      E.children("".concat(this.tabPaneElementSelector, ":not(").concat(this.activeSelector, ")")).attr('tabindex', '-1');
      E.children("".concat(this.tabPaneElementSelector).concat(this.activeSelector)).removeAttr('tabindex');
      E.find("> ".concat(this.tabPaneElementSelector, ":not(").concat(this.activeSelector, ") [tabindex]:not([data-original-tab-index])")).toArray().forEach(function (node) {
        node.dataset.originalTabIndex = node.tabIndex;
        node.setAttribute('tabindex', '-1');
      });
      E.find("> ".concat(this.tabPaneElementSelector, ":not(").concat(this.activeSelector, ") *:not([data-original-tab-index])")).toArray().forEach(function (node) {
        node.dataset.originalTabIndex = '';
        node.setAttribute('tabindex', -1);
      });
      E.find("> ".concat(this.tabPaneElementSelector).concat(this.activeSelector, " [data-original-tab-index]")).toArray().forEach(function (node) {
        if (node.dataset.originalTabIndex) node.setAttribute('tabindex', node.dataset.originalTabIndex);else node.removeAttribute('tabindex');
        delete node.dataset.originalTabIndex;
      });

      if (E.find("".concat(this.tabPaneElementSelector).concat(this.activeSelector)).length == 1) {
        if (E.find("".concat(this.tabPaneElementSelector)).length == 1) {
          E.parent().css({
            transition: 'none',
            height: 'auto'
          });
          E.css({
            transition: 'none',
            height: 'auto'
          });
        } else {
          var EH = E.find("".concat(this.tabPaneElementSelector).concat(this.activeSelector, " > ").concat(this.tabPaneContentSelector));
          var H = [].slice.call(EH).map(function (v) {
            return v.getBoundingClientRect();
          });
          var tp = H.reduce(function (a, b) {
            return a.top < b.top ? a : b;
          }).top;
          var bp = H.reduce(function (a, b) {
            return a.bottom > b.bottom ? a : b;
          }).bottom;
          var height = bp - tp;
          E.parent().css({
            transition: 'height .3s ease',
            height: E.parent().offsetHeight + 'px'
          });
          setTimeout(function () {
            return E.parent().css('height', "".concat(height, "px"));
          }, 0);
        }
      }
    }
  }, {
    key: "fixSoon",
    value: function fixSoon() {
      if (this.fixSoonTimeout) clearTimeout(this.fixSoonTimeout);
      this.fixSoonTimeout = setTimeout(this.setup, 64);
    }
  }, {
    key: "setup",
    value: function setup() {
      var _this = this;

      this.fix();
      (0, _jquery.default)(this.tabContentRoot).find("".concat(this.tabRootElementSelector, " ").concat(this.tabPaneElementSelector)).off('shown.bs.tab', this.tabShown).on('shown.bs.tab', this.tabShown);
      (0, _jquery.default)(window).off('resize', this.resized).on('resize', this.resized);
      [].forEach.call(this.tabContentRoot.querySelectorAll("".concat(this.tabRootElementSelector, " ").concat(this.tabContentElementSelector)), function (node) {
        // node.addEventListener('pointerdown', this.tabPointerDown);
        node.removeEventListener('touchstart', _this.tabTouchStart);
        node.addEventListener('touchstart', _this.tabTouchStart); // node.addEventListener('pointermove', this.tabPointerMove);

        node.removeEventListener('touchmove', _this.tabTouchMove);
        node.addEventListener('touchmove', _this.tabTouchMove); // node.addEventListener('pointerup', this.tabMoveEnd);

        node.removeEventListener('touchend', _this.tabMoveEnd);
        node.addEventListener('touchend', _this.tabMoveEnd);
      });
    }
  }, {
    key: "tabShown",
    value: function tabShown(_ref) {
      var target = _ref.currentTarget;
      var position = (0, _jquery.default)(target).prevAll(this.tabPaneElementSelector).length,
          offset = (0 - position) * 100;
      (0, _jquery.default)(target).parents(this.tabContentElementSelector).css('transform', "translate(".concat(offset, "%, 0)"));
      setTimeout(this.fix, 0);
    }
  }, {
    key: "resized",
    value: function resized() {
      var E = (0, _jquery.default)(this.tabContentRoot).find("".concat(this.tabRootElementSelector, " ").concat(this.tabContentElementSelector));

      if (E && E.length) {
        var activeTab = E.find("".concat(this.tabPaneElementSelector).concat(this.activeSelector, " > ").concat(this.tabPaneContentSelector));

        if (activeTab && activeTab.length) {
          var EH = activeTab;
          var H = [].slice.call(EH).map(function (v) {
            return v.getBoundingClientRect();
          });
          var tp = H.reduce(function (a, b) {
            return a.top < b.top ? a : b;
          }).top;
          var bp = H.reduce(function (a, b) {
            return a.bottom > b.bottom ? a : b;
          }).bottom;
          var height = bp - tp;
          E.css({
            height: "".concat(height, "px")
          });
        }
      }
    } // Swiping between tabs

  }, {
    key: "tabPointerDown",
    value: function tabPointerDown(_ref2) {
      var clientX = _ref2.clientX,
          clientY = _ref2.clientY,
          pointerId = _ref2.pointerId,
          target = _ref2.currentTarget;

      if (this.paused) {
        this.ignored = true;
        return;
      }

      if (this.t0) return;
      this.t0 = {
        clientX: clientX,
        clientY: clientY,
        pointerId: pointerId,
        mode: 'pointer'
      };
      target.setPointerCapture(pointerId);
      this.ignored = null;
      this.beginTabMove(target);
    }
  }, {
    key: "tabMouseDown",
    value: function tabMouseDown(_ref3) {
      var clientX = _ref3.clientX,
          clientY = _ref3.clientY,
          target = _ref3.currentTarget;

      if (this.paused) {
        this.ignored = true;
        return;
      }

      if (this.t0) return;
      this.t0 = {
        clientX: clientX,
        clientY: clientY,
        target: target,
        mode: 'mouse'
      };
      this.ignored = null;
      this.beginTabMove(target);
    }
  }, {
    key: "tabTouchStart",
    value: function tabTouchStart(_ref4) {
      var touches = _ref4.touches,
          target = _ref4.currentTarget;

      if (this.paused) {
        this.ignored = true;
        return;
      }

      if (this.t0) return;
      var _touches$ = touches[0],
          clientX = _touches$.clientX,
          clientY = _touches$.clientY,
          identifier = _touches$.identifier;
      this.t0 = {
        clientX: clientX,
        clientY: clientY,
        identifier: identifier,
        mode: 'touch'
      };
      this.ignored = null;
      this.beginTabMove(target);
    }
  }, {
    key: "beginTabMove",
    value: function beginTabMove(target) {
      this.finished = false;
      this.wh = (0, _jquery.default)(window).height();
      this.ww = (0, _jquery.default)(window).width();
      this.ignored = null;
      (0, _jquery.default)(target).css({
        'user-select': 'none',
        '-moz-user-select': 'none',
        '-webkit-user-select': 'none',
        '-ms-user-select': 'none'
      });
    }
  }, {
    key: "tabMoveFilter",
    value: function tabMoveFilter(clientX, clientY) {
      if (Math.abs(this.t0.clientY - clientY) > 0.05 * this.wh) {
        return {
          ignored: true
        };
      }

      if (Math.abs(this.t0.clientX - clientX) > 0.05 * this.wh) {
        return {
          clientX: clientX,
          clientY: clientY
        };
      }

      return {
        ignored: null
      };
    }
  }, {
    key: "tabPointerFilter",
    value: function tabPointerFilter(_ref5) {
      var pointerId = _ref5.pointerId,
          clientX = _ref5.clientX,
          clientY = _ref5.clientY;

      if (this.t0.type != 'pointer') {
        return {
          ignored: null
        };
      }

      if (this.t0.pointerId != pointerId) {
        return {
          ignored: true
        };
      }

      return this.tabMoveFilter(clientX, clientY);
    }
  }, {
    key: "tabMouseFilter",
    value: function tabMouseFilter(_ref6) {
      var clientX = _ref6.clientX,
          clientY = _ref6.clientY;

      if (this.t0.type != 'mouse') {
        return {
          ignored: null
        };
      }

      return this.tabMoveFilter(clientX, clientY);
    }
  }, {
    key: "tabTouchFilter",
    value: function tabTouchFilter(_ref7) {
      var touches = _ref7.touches;
      var _touches$2 = touches[0],
          identifier = _touches$2.identifier,
          clientX = _touches$2.clientX,
          clientY = _touches$2.clientY;

      if (this.t0.type != 'touch') {
        return {
          ignored: null
        };
      }

      if (this.t0.identifier != identifier) {
        return {
          ignored: true
        };
      }

      return this.tabMoveFilter(clientX, clientY);
    }
  }, {
    key: "tabMove",
    value: function tabMove(filter, event) {
      if (this.finished) return;
      var r;

      if (this.t0 && this.ignored === null) {
        r = filter(event);

        if (r.ignored === true || r.ignored === false) {
          this.ignored = r.ignored;
        }

        if (r.ignored === true || r.ignored === null) return;
      }

      if (this.ignored === false) {
        var _r = r,
            clientX = _r.clientX,
            clientY = _r.clientY;

        if (Math.abs(clientX - this.t0.clientX) > 0.05 * this.ww) {
          d = clientX - this.t0.clientX;
        } else {
          d = 0;
        }

        (0, _jquery.default)(event.currentTarget).parents(this.tabRootElementSelector).css('transform', "translate(".concat(0 - (this.t0.clientX - clientX), "px, 0)"));
      }
    }
  }, {
    key: "tabPointerMove",
    value: function tabPointerMove(event) {
      return this.tabMove(this.tabPointerFilter, event);
    }
  }, {
    key: "tabTouchMove",
    value: function tabTouchMove(event) {
      return this.tabMove(this.tabTouchFilter, event);
    }
  }, {
    key: "tabMouseMove",
    value: function tabMouseMove(event) {
      return this.tabMove(this.tabMouseFilter, event);
    }
  }, {
    key: "tabMoveEnd",
    value: function tabMoveEnd(_ref8) {
      var _this2 = this;

      var type = _ref8.type,
          target = _ref8.currentTarget,
          pointerId = _ref8.pointerId;

      if (type == 'mouseout' && this.t0 && this.t0.mode == 'mouse') {
        if (target != this.t0.target) {
          return;
        }
      }

      if (type == 'pointerup') {
        target.releasePointerCapture(pointerId);
      }

      if (this.t0 && this.ignored === false) {
        if (type == 'mouseout') d = 0;
        if (t == -1) tgt = (0, _jquery.default)(target).children("".concat(this.tabPaneElementSelector).concat(this.activeSelector)).prev(this.tabPaneElementSelector)[0];else tgt = (0, _jquery.default)(target).children("".concat(this.tabPaneElementSelector).concat(this.activeSelector)).next(this.tabPaneElementSelector)[0];
        (0, _jquery.default)(target).parents(this.tabRootElementSelector).css('transition', '.3s ease-in-out');
        this.paused = true;
        setTimeout(function () {
          (0, _jquery.default)(target).parents(_this2.tabRootElementSelector).css('transform', '');
          setTimeout(function () {
            (0, _jquery.default)(target).parents(_this2.tabRootElementSelector).css('transition', '');
            _this2.paused = false;
            _this2.ignored = null;
            _this2.t0 = null;
            _this2.finished = null;
          }, 300);
        }, 0);

        if (tgt) {
          (0, _jquery.default)(this.tabContentRoot).find("".concat(this.tabBarSelector, " a[data-target=\"#").concat(tgt.id, "\"]")).tab('show');
          finished = true;
        }
      } else if (!this.paused) {
        this.ignored = this.t0 = this.finished = null;
      }

      (0, _jquery.default)(target).css({
        'user-select': '',
        '-moz-user-select': '',
        '-webkit-user-select': '',
        '-ms-user-select': ''
      });
    }
  }]);
  return TabbedContentHelper;
}(), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "fix", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "fix"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "fixSoon", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "fixSoon"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setup", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabShown", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabShown"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "resized", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "resized"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabPointerDown", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabPointerDown"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMouseDown", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMouseDown"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabTouchStart", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabTouchStart"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "beginTabMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "beginTabMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMoveFilter", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMoveFilter"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabPointerFilter", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabPointerFilter"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMouseFilter", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMouseFilter"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabTouchFilter", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabTouchFilter"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabPointerMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabPointerMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabTouchMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabTouchMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMouseMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMouseMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabMoveEnd", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "tabMoveEnd"), _class.prototype)), _class);
exports.default = TabbedContentHelper;
var globalHelper = new TabbedContentHelper();

function fixSoon() {
  globalHelper.fixSoon();
}

function fix() {
  globalHelper.fix();
}

function setup() {
  globalHelper.setup();
}